if (!customElements.get('complete-your-setup')) {
  customElements.define(
    'complete-your-setup',
    class CompleteYourSetup extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.handleAddClick.bind(this));
      }

      handleAddClick(evt) {
        const button = evt.target.closest('.complete-your-setup__add');
        if (!button || button.classList.contains('is-added') || button.getAttribute('aria-disabled') === 'true')
          return;

        button.setAttribute('aria-disabled', 'true');

        const body = JSON.stringify({
          id: button.dataset.variantId,
          quantity: 1,
          sections: ['cart-notification-product', 'cart-notification-button', 'cart-notification-shipping', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              button.removeAttribute('aria-disabled');
              return;
            }
            button.classList.add('is-added');
            const cartNotification = document.querySelector('cart-notification');
            if (cartNotification) cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
            button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
